import React, { FC } from "react";
import cx from "classnames";

import styles from "./InfoCardWrapper.module.scss";

type Props = {
  children: React.ReactNode;
  className?: string;
};

const InfoCardWrapper: FC<Props> = ({ children, className }) => {
  return <div className={cx(styles.infoCardWrapper, className)}>{children}</div>;
};

export default InfoCardWrapper;
